// extracted by mini-css-extract-plugin
export default {"wrapper":"Q8","container":"R8","title":"S8","carousel":"T8","review":"U8","name":"V8","rating":"W8","heading":"X8","body":"Y8"};
    if(module.hot) {
      // 1713361655987
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  